import { ReportBuilderDataSourceId } from '@principle-theorem/principle-core/interfaces';
import { AccountCreditsDataSource } from './data-source-instances/account-credits-data-source';
import { AppointmentServiceCodesDataSource } from './data-source-instances/appointment-service-codes-data-source';
import { AppointmentTreatmentsDataSource } from './data-source-instances/appointment-treatments-data-source';
import { AppointmentsDataSource } from './data-source-instances/appointments-data-source';
import { InvoicesDataSource } from './data-source-instances/invoices-data-source';
import { LabJobsDataSource } from './data-source-instances/lab-jobs-data-source';
import { PatientInteractionsDataSource } from './data-source-instances/patient-interactions-data-source';
import { PatientsDataSource } from './data-source-instances/patients-data-source';
import { PractitionerIncomeDataSource } from './data-source-instances/practitioner-income-data-source';
import { SchedulingEventsDataSource } from './data-source-instances/scheduling-events-data-source';
import { TransactionsDataSource } from './data-source-instances/transactions-data-source';
import { ReportBuilderDataSourceInstance } from './report-builder-data-source-instance';

export const REPORT_BUILDER_DATA_SOURCES: ReportBuilderDataSourceInstance[] = [
  new AccountCreditsDataSource(),
  new AppointmentsDataSource(),
  new AppointmentServiceCodesDataSource(),
  new AppointmentTreatmentsDataSource(),
  new InvoicesDataSource(),
  new LabJobsDataSource(),
  new PatientsDataSource(),
  new PatientInteractionsDataSource(),
  new PractitionerIncomeDataSource(),
  new TransactionsDataSource(),
  new SchedulingEventsDataSource(),
];

export function resolveDataSource<T extends ReportBuilderDataSourceInstance>(
  id: ReportBuilderDataSourceId | undefined,
  sources: T[]
): T | undefined {
  if (!id) {
    return;
  }
  const result = sources.find((source) => source.id === id);
  if (!result) {
    // eslint-disable-next-line no-console
    console.error(`Couldn't resolve datasource: ${id}`);
  }
  return result;
}
